module.exports = __webpack_public_path__ + "img/d2.3abb8bf3.png";